import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon } from '../../../config/variables';
import { navigateRoute } from '../../../utils/HelperFunctions';
import { ICity } from '../types/interfaces';
import { ITableContainerProps } from '../../../types/Interfaces';
import DeleteButton from '../../../components/buttons/DeleteButton';
import { useTranslation } from 'react-i18next';

const CitiesTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<ICity[]>) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });
  const { i18n } = useTranslation();

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header: any, index: number) => (
          <span className={`head ${header.customClass}`} key={index}>
            {header.label}
          </span>
        ))}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item: any, index: number) => (
              <div
                className="item clickable has_logo body_types"
                key={index}
                onClick={(e) => {
                  navigateRoute(e, `/cities/create-city/${item.id}`, navigate);
                }}
              >
                <div className="column">{item?.id || '-'}</div>
                <div className="column">
                  <div className="capitalize">{item?.name?.[i18n.language] || '-'}</div>
                </div>
                <div className="column actions actions_col">
                  <div
                    className="action_btn edit"
                    onClick={(e) => {
                      navigateRoute(e, `/cities/create-city/${item.id}`, navigate);
                    }}
                  >
                    {editIcon}
                  </div>
                  <DeleteButton deleteRoute={`/admin/cities`} queryKey="cities" id={item.id} />
                </div>
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default CitiesTableContainer;
